import { useSelector } from 'react-redux';
import { selectSubscriptions } from './subscriptionsSlice';

export const useSubscriptions = () => {
  const {
    subscription,
    updatingSubscription,
    entitledFeatures,
    updatingEntitledFeatures,
  } = useSelector(selectSubscriptions);

  return {
    subscription,
    updatingSubscription,
    entitledFeatures,
    updatingEntitledFeatures,
  };
};
